export default __webpack_public_path__ + "static/media/spaceman5.61ff622d.png";